/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "bills": {
            "nested": {
              "CommonPointOfSaleAttributes": {
                "nested": {
                  "VirtualRegister": {
                    "fields": {
                      "virtualRegisterToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "businessDayToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "transactionNumber": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "receiptToken": {
                        "type": "string",
                        "id": 5,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              },
              "SquareProduct": {
                "values": {
                  "UNKNOWN_DO_NOT_SET": 0,
                  "REGISTER": 1,
                  "CASH": 2,
                  "MARKET": 3,
                  "ORDER": 4,
                  "EXTERNAL_API": 5,
                  "BILLING": 6,
                  "APPOINTMENTS": 7,
                  "STORE": 8,
                  "INVOICES": 9,
                  "ONLINE_STORE": 10,
                  "STARBUCKS": 11,
                  "WHITE_LABEL": 12,
                  "PAYROLL": 13,
                  "CAPITAL": 14,
                  "REGISTER_HARDWARE": 15
                }
              },
              "SquareProductAttributes": {
                "fields": {
                  "register": {
                    "type": ".squareup.client.bills.SquareProductAttributes.Register",
                    "id": 1,
                    "rule": "optional"
                  },
                  "retailPointOfSale": {
                    "type": ".squareup.client.bills.SquareProductAttributes.RetailPointOfSale",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Register": {
                    "fields": {
                      "isLegacyPaymentTransaction": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "RetailPointOfSale": {
                    "fields": {
                      "virtualRegister": {
                        "type": ".squareup.client.bills.CommonPointOfSaleAttributes.VirtualRegister",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.CommonPointOfSaleAttributes?.nested?.VirtualRegister && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SquareProduct && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SquareProductAttributes && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SquareProductAttributes?.nested?.Register && !$root.nested?.squareup?.nested?.client?.nested?.bills?.nested?.SquareProductAttributes?.nested?.RetailPointOfSale) {
  $root.addJSON(jsonData);
}

/**
 * Attributes that are common to multiple POS clients.
 *
 * SOURCE CommonPointOfSaleAttributes @ squareup/client/bills/square_product_attributes.proto at 14:1
 */
export const CommonPointOfSaleAttributes = {};
/**
 * SOURCE VirtualRegister @ squareup/client/bills/square_product_attributes.proto at 15:3
 */
CommonPointOfSaleAttributes.VirtualRegister = $root.lookupType('squareup.client.bills.CommonPointOfSaleAttributes.VirtualRegister');
fixType(CommonPointOfSaleAttributes.VirtualRegister);
Builder.createAndAttachToType(CommonPointOfSaleAttributes.VirtualRegister);
/**
 * An emumeration of Square products that create payments.
 *
 * SOURCE SquareProduct @ squareup/client/bills/square_product_attributes.proto at 44:1
 */
export const SquareProduct = $root.lookupEnum('squareup.client.bills.SquareProduct').values;
/**
 * Product-specific bill-level attributes. At most one field should be set.
 *
 * The names of these messages correspond with the SquareProduct creating the bill.
 *
 * SOURCE SquareProductAttributes @ squareup/client/bills/square_product_attributes.proto at 103:1
 */
export const SquareProductAttributes = $root.lookupType('squareup.client.bills.SquareProductAttributes');
fixType(SquareProductAttributes);
Builder.createAndAttachToType(SquareProductAttributes);
/**
 * SOURCE Register @ squareup/client/bills/square_product_attributes.proto at 104:3
 */
SquareProductAttributes.Register = $root.lookupType('squareup.client.bills.SquareProductAttributes.Register');
fixType(SquareProductAttributes.Register);
Builder.createAndAttachToType(SquareProductAttributes.Register);
/**
 * SOURCE RetailPointOfSale @ squareup/client/bills/square_product_attributes.proto at 112:3
 */
SquareProductAttributes.RetailPointOfSale = $root.lookupType('squareup.client.bills.SquareProductAttributes.RetailPointOfSale');
fixType(SquareProductAttributes.RetailPointOfSale);
Builder.createAndAttachToType(SquareProductAttributes.RetailPointOfSale);